import { useToast } from '@/components/ui/toast';
import type { ToastVariants } from '@/components/ui/toast';
import type { ToasterToast } from '@/components/ui/toast/use-toast.ts';
import { syncToWebViewAction } from '@/actions/sync/SyncToWebViewAction.ts';
import { SYNC_TO_WEB_VIEW_KEYS } from '@/types/sync/SyncKeys.ts';

export const createTextToast = (
    title: string,
    description: string | undefined,
    variant: ToastVariants['variant'],
    pushToWebView: boolean,
) => {
    const { toast } = useToast();

    const props: Omit<ToasterToast, 'id'> = {
        title: title,
        description: description,
        variant: variant,
    };

    toast(props);

    if (pushToWebView) {
        void syncToWebViewAction(
            SYNC_TO_WEB_VIEW_KEYS.toast,
            JSON.stringify({
                title: title,
                description: description,
                variant: variant,
            }),
        );
    }
};
